<template>
    <Card style="margin-top:320px;height:300px;line-height:200px;" :bordered="false">
        <div style="text-align:center">
            <h3>The toolset for device</h3>
        </div>
    </Card>
</template>

<script>
import logo from '@/assets/images/logo.jpg'
export default {
  name: 'join_page',
  data () {
    return {
      logo
    }
  }
}
</script>

<style lang="less">

</style>
